import React from "react";
import { connect, getIn, FormikContextType } from "formik";

type Props = {
  name: string;
  children(errMsg: string | null): React.ReactNode;
}

/**
 * Get the Formik form errors for a given input `name`. This will render the
 * child regardless whether it has an error (if you want that functionality
 * use Formik's <ErrorMessage/> component instead)
 *
 *  Example:
 *  ```
 *  <FormErrors name="age">
 *    { (errMsg) => <div>Age has an error?: {errMsg ? 'Yes' : 'No'} </div> }
 *  </FormErrors>
 *  ```
 */
const FormErrors: React.FC<Props & { formik: FormikContextType<any> }> = props => {
  const error = getIn(props.formik.errors, props.name);
  const touched = getIn(props.formik.touched, props.name);
  return <>{props.children(error && touched ? error : null)}</>;
};

export default connect<Props, Props & { formik: FormikContextType<any> }>(FormErrors);
